import { render, staticRenderFns } from "./PageBackWithLink.vue?vue&type=template&id=269a5ba4"
import script from "./PageBackWithLink.vue?vue&type=script&lang=js"
export * from "./PageBackWithLink.vue?vue&type=script&lang=js"
import style0 from "./PageBackWithLink.vue?vue&type=style&index=0&id=269a5ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports